/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { ForgotPassword, NotFound, SetPassword, VerifyEmail, AdminLogin } from 'features/components';
import AppLayout from 'features/components/base/layouts/AppLayout';
import { isAuthenticated, isAuthorized } from 'shared/settings/auth';

// style imports
import 'react-toastify/dist/ReactToastify.css';
import { SalesService } from 'shared/services';
import store from 'features/store';
//import LogRocket from 'logrocket';
//import { logRocketDevId } from 'shared/settings/config';
// import store from 'features/store';

/**
 * routing for all features components
 * 
 * @param props
 * 
 * @return routing for all features components
 * 
**/

export class FeaturesRouter extends Component {

    constructor(props) {
        super(props);

        this.state = {
            page: false
        };
    }
    componentDidMount() {
        // if (isAuthorized()) {
        //     let userdetails = store.getState().user;
        //     LogRocket.init(logRocketDevId);
        //     LogRocket.identify(userdetails.id.toString(), {
        //         name: `${userdetails.lastName}, ${userdetails.firstName}`,
        //         email: userdetails.email,

        //         // Add your own custom user variables here, ie:
        //         subscriptionType: 'pro'
        //     });
        //     LogRocket.getSessionURL(sessionURL => {
        //         console.table("water bottle", sessionURL);
        //     });
        // }
        isAuthenticated(this.props.history)
            .then(res => {
                this.setState({ page: true }, () => {
                    const data = {
                        "filter": [
                            { "field": "status", "value": "Active", "op": "=", "join": "AND" },
                            { "field": "advertisetype", "value": "Banner", "op": "=", "join": "AND" }
                        ]
                    };
                    SalesService.getAdvList(data).then( response => {
                        let advData = response.data.data;
                        advData.map((data, index) => {
                            if (data.advertisetype == "Banner") {
                                store.dispatch({ type: 'PREMIER_BANNER_IMAGE', payload: { bannerData: data} });
                            }
                        })
                    }).catch((error) => {
                       
                    });
                    
                });
            });
    }

    render() {
        return (this.state.page ?
            <>
                <Switch>
                    <Route exact path="/admin">
                        {
                            isAuthorized() ? <Redirect to="/" /> : <AdminLogin {...this.props} />
                        }
                    </Route>
                    <Route exact path="/forgot-password">
                        {
                            isAuthorized() ? <Redirect to="/" /> : <ForgotPassword {...this.props} />
                        }
                    </Route>
                    <Route exact path="/set-password">
                        {
                            isAuthorized() ? <Redirect to="/" /> :  <SetPassword {...this.props} />
                        }
                    </Route>
                    <Route exact path="/verify-email">
                        {
                            () => {
                                return isAuthorized(true) ? <Redirect to="/" /> : <VerifyEmail {...this.props} />
                            }
                        }
                    </Route>
                    <Route>
                        {
                            <AppLayout {...this.props} />
                        }
                    </Route>
                    <Route exact path="/not-found" component={NotFound} />

                    <Redirect to="/" />
                </Switch>
            </> :
            null
        );
    }
}
